<template>
  <!-- The tooltip sits on this span, not on the button: a disabled button
       gets no pointer events, so a tooltip on it never opens. The tooltip
       listens for focus on the span only, and focus does not bubble, so
       focusin opens it for a keyboard user. -->
  <span
    ref="wrapper"
    v-tooltip.placementBottom.html.textLeft="tooltip"
    class="tw-group tw-flex tw-h-full"
    @focusin="wrapper?.tooltip?.show()"
    @focusout="wrapper?.tooltip?.hide()"
  >
    <SfButtonDs
      v-bind="$attrs"
      variant="tertiary"
      class="!tw-h-full !tw-rounded-none !tw-border-0"
      :disabled="disabled"
      :aria-label="label"
      :data-heap="dataHeap"
      :data-testid="dataTestid"
      @click.stop="$emit('click')"
    >
      <span class="tw-relative tw-block tw-w-4 tw-h-4 tw-shrink-0 tw-z-10">
        <span
          class="
            tw-absolute
            tw-inset-0
            tw-flex
            tw-items-center
            tw-justify-center
            tw-transition-opacity
            tw-duration-150
            group-hover:tw-opacity-0
          "
        >
          <slot name="default" />
        </span>
        <span
          class="
            tw-absolute
            tw-inset-0
            tw-flex
            tw-items-center
            tw-justify-center
            tw-opacity-0
            tw-transition-opacity
            tw-duration-150
            group-hover:tw-opacity-100
          "
        >
          <slot name="hover" />
        </span>
      </span>
    </SfButtonDs>
  </span>
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'
import { SfButtonDs } from '@silverfin/ui-components'

defineOptions({ inheritAttrs: false })

defineProps<{
  tooltip: string
  label: string
  disabled?: boolean
  dataHeap: string
  dataTestid: string
}>()

defineEmits<{ click: [] }>()

const wrapper =
  useTemplateRef<HTMLElement & { tooltip?: { show(): void; hide(): void } }>(
    'wrapper'
  )
</script>
